// extracted by mini-css-extract-plugin
export default {"apartments-section":"ApartmentsSection_apartments-section__nvI-l","apartment-one":"ApartmentsSection_apartment-one__v2uJb","apartment-two":"ApartmentsSection_apartment-two__p6hNC"};